import Axios from 'axios';

Axios.defaults.baseURL = 'https://testapi.opnie.com/api';
//Axios.defaults.baseURL = 'https://localhost:7177/api';

export const axiosInstance = Axios.create({});
